import React from 'react';

import moment from 'moment';
import 'moment/locale/es';
import { Checkbox, Button } from 'antd/lib';
import { Form } from '@ant-design/compatible';
const FormItem = Form.Item;
moment.locale();

class FormAsociaciones extends React.Component {
  state = {
    percibeHechos: true,
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let valor = this.evaluarPuntaje(values);

        let respuestas = {};

        if (respuestas.percibeHechos) {
          respuestas = {
            ...values,
            valor,
          };
        } else {
          // Reseteo todas las variables ya que no percibe hechos asociados.
          respuestas = {
            ...values,
            valor,
            provocaHijos: false,
            provocaAdiccion: false,
            provocaAutonomia: false,
            provocaJugadorCompulsivo: false,
            provocaCelos: false,
            provocaProblemasLaborales: false,
            hechosImpredeciblesOConfusos: false,
          };
        }

        // console.log(this.props);
        this.props.onSubmit(respuestas);
      }
    });
  };

  evaluarPuntaje = respuestas => {
    // console.log("Entre a evaluar el puntaje con....");
    // console.log(respuestas);

    let valor = 0;
    //Lo que busco a continuacion es sumar los valores, pero como estan en STRINGS, primero debo aplicar el operador UNARIO + para convertirlos a INT.

    if (respuestas.percibeHechos) {
      if (respuestas.provocaHijos) {
        valor = valor + 1;
      }

      if (respuestas.provocaAdiccion) {
        valor = valor + 3;
      }

      if (respuestas.provocaAutonomia) {
        valor = valor + 3;
      }

      if (respuestas.provocaJugadorCompulsivo) {
        valor = valor + 1;
      }

      if (respuestas.provocaCelos) {
        valor = valor + 3;
      }

      if (respuestas.provocaProblemasLaborales) {
        valor = valor + 1;
      }

      if (respuestas.hechosImpredeciblesOConfusos) {
        valor = valor + 3;
      }
    } else {
      valor = valor + 3;
    }

    // console.log("El resultado es.... ", valor);

    return valor;
  };

  onChange = e => {
    // console.log(`checked = ${e.target.checked}`);
    this.setState({
      ...this.state,
      percibeHechos: !e.target.checked,
    });
  };

  render() {
    moment.locale();
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <div>
        <h1 className="tituloForm">
          Evaluación de Hechos que Asocia a los Episodios de Violencia
        </h1>

        <Form onSubmit={this.handleSubmit} className="formulariosViolencia">
          {' '}
          <FormItem {...formItemLayout} label="No percibe hechos asociados">
            {getFieldDecorator('percibeHechos', {
              initialValue: false,
            })(<Checkbox onChange={this.onChange} />)}
          </FormItem>
          {this.state.percibeHechos && (
            <div>
              <FormItem
                {...formItemLayout}
                label="Embarazo/Nacimiento de hijos"
              >
                {getFieldDecorator('provocaHijos', {
                  initialValue: false,
                })(<Checkbox />)}
              </FormItem>

              <FormItem
                {...formItemLayout}
                label="Alcohol/sustancia psicoadictivas"
              >
                {getFieldDecorator('provocaAdiccion', {
                  initialValue: false,
                })(<Checkbox />)}
              </FormItem>

              <FormItem {...formItemLayout} label="Autonomía de la victima">
                {getFieldDecorator('provocaAutonomia', {
                  initialValue: false,
                })(<Checkbox />)}
              </FormItem>

              <FormItem {...formItemLayout} label="Jugador compulsivo">
                {getFieldDecorator('provocaJugadorCompulsivo', {
                  initialValue: false,
                })(<Checkbox />)}
              </FormItem>

              <FormItem {...formItemLayout} label="Celos">
                {getFieldDecorator('provocaCelos', {
                  initialValue: false,
                })(<Checkbox />)}
              </FormItem>

              <FormItem {...formItemLayout} label="Problemas Laborales">
                {getFieldDecorator('provocaProblemasLaborales', {
                  initialValue: false,
                })(<Checkbox />)}
              </FormItem>

              <FormItem {...formItemLayout} label="Impredecible o Confuso">
                {getFieldDecorator('hechosImpredeciblesOConfusos', {
                  initialValue: false,
                })(<Checkbox />)}
              </FormItem>
            </div>
          )}
          <FormItem {...tailFormItemLayout}>
            <Button style={{ margin: 10 }} type="primary" htmlType="submit">
              Siguiente
            </Button>
            <Button
              style={{ margin: 10 }}
              type="danger"
              onClick={this.props.onCancel}
            >
              Cancelar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create()(FormAsociaciones);
